
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/public-relations",
      function () {
        return require("private-next-pages/public-relations.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/public-relations"])
      });
    }
  